<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<template>
  <v-container>
    <!-- <v-layout text-center wrap> -->
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>会員証登録</h4>
        </span>
      </span>
      <span id="header_logo"
        ><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px"
      /></span>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <h4>&ensp;&ensp;{{ $shopname }}&ensp;&ensp;</h4>
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4" id="regist_button">
          <v-btn
            large
            color="info"
            @click="go2regist"
            title="新規会員証発行"
            id="return2top_btn"
            width="100%"
            >&emsp;新規にデジタル会員証を発行する&emsp;</v-btn
          >
        </div>
      </v-flex>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4" id="migration_button">
          <v-btn
            large
            color="success"
            @click="migration"
            title="既存カード登録"
            class="migration_btn"
            width="100%"
            >&emsp;既存カード情報を登録する&emsp;</v-btn
          >
        </div>
      </v-flex>
      <br />
      <div>
        <v-snackbar
          v-model="snackbarFlag"
          color="primary"
          multi-line
          :timeout="snackbarTimeout"
          top
        >
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4">
          <br />
          <br />
          <span id="copyright"
            ><a
              href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank"
              >&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright
              &copy; BUSICOM.Co.,ltd. </a
            ><br />&emsp;v2.5.0.1&emsp;</span
          >
        </div>
      </v-flex>
      <span id="misemeg_uid" hidden></span>
      <span id="chg_digit_info" hidden></span>
    </v-layout>
  </v-container>
</template>

<style>
.v-main {
  background-color: #f3f3f3;
}
#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}

#header_logo {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  margin-left: 0px;
  margin-right: 100px;
}
#member_info_tbl {
  margin: 0 auto;
  color: navy;
}
#line_logout {
  margin: 0 auto;
}
#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
</style>
<script>
// for encrypt message
import crypto from "crypto-js";
var CryptoJS = require("crypto-js");
// var dts = new Date().getDate();
var dts = "651127";
var passPhrase =
  "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

// for HTTP response
import axios from "axios";

export default {
  data() {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: "",
      name: "",
      imgURL: "",
      userId: "",
      email: "",
      barcode_url: "",
      inClient: false,
    };
  },
  created() {
    this.initializeLiff();
    //ヘッダの幅を画面幅に合わせる
    // $('#main_title').css('width',window.outerWidth);
  },
  mounted() {
    //ヘッダの幅を画面幅に合わせる
    $("#main_title").css("width", window.outerWidth);
    //メルアドに対応するみせめぐUserIDを取得する
    this.getUserID();
    this.getChangeDigitInfo();
  },
  methods: {
    initializeLiff: function () {
      var me = this;
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID,
        },
        (data) => {},
        (err) => {
          console.log("LIFF initialization failed", err);
        }
      );
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout();
        this.$router.push({ name: "home" });
      }
    },
    return2top: function () {
      // デジタル会員証表示ボタン（＝TOP画面に戻る）
      this.$router.push({ name: "home" });
    },
    go2regist: function () {
      // 新規デジタル会員証登録画面に遷移
      this.$router.push({ name: "regist" });
    },
    go2migration: function () {
      // 新規デジタル会員証登録画面に遷移
      this.$router.push({ name: "migration" });
    },
    /**
     * LIFFログイン情報から取得したメルアドを持つみせめぐユーザーのUIDを取得する
     */
    getUserID: async function () {
      // 会員証移行処理に進むために登録した会員情報の一部を取得する
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      // 引数１．mail address
      this.initializeLiff();
      var email = "undefined";
      try {
        const idToken = liff.getDecodedIDToken();
        console.log(idToken.email); // print decoded idToken object
        //メルアドが取得できれば表示、取得エラーの場合は入力を促す
        email = idToken.email;
      } catch (Exception) {
        email = "";
      }
      if (email == "undefined" || email == null || email == "") {
        var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
        var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
        email = dec_email.toString(CryptoJS.enc.Utf8);
      }
      //----------------------------
      // みせめぐユーザーIDの取得
      //----------------------------
      var codeinfo_url = "";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        codeinfo_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemeg.jp/";
        } else {
          codeinfo_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemegu.jp/";
        } else {
          codeinfo_url = "https://sv1.misemegu.jp/";
        }
      }
      codeinfo_url += "appli/line/";
      codeinfo_url += "getMisemegUID.php?mail=";
      codeinfo_url += email;
      codeinfo_url +=
        "&security=" +
        md5(
          email +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            email +
            "!Busicom04510" +
            mmddyyyy
        );
      // window.alert(codeinfo_url);
      await axios
        .get(codeinfo_url)
        // .then((response) => this.users = response.data)
        .then(
          (response) => (document.getElementById("misemeg_uid").innerHTML = response.data)
        )
        // .then((response) => $('#member_info').val = response.data)
        .catch((error) => console.log(error));
    },
    /**
     * 会員証桁数変更情報を取得する
     */
    getChangeDigitInfo: async function () {
      // md5ライブラリの読み込み
      var md5 = require("md5");
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;
      var email = "undefined";
      try {
        const idToken = liff.getDecodedIDToken();
        console.log(idToken.email); // print decoded idToken object
        email = idToken.email;
      } catch (Exception) {
        email = "";
      }
      //メルアドが取得できない場合はLocalStorageから取得する
      if (email == "undefined" || email == null || email == "") {
        var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
        var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
        email = dec_email.toString(CryptoJS.enc.Utf8);
      }
      var codeinfo_url = "";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        codeinfo_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemeg.jp/";
        } else {
          codeinfo_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemegu.jp/";
        } else {
          codeinfo_url = "https://sv1.misemegu.jp/";
        }
      }
      //オーナーIDをグローバル変数から取得する（※初期値は試験用）
      var prmid = this.$_t_prmid();
      //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
      if (debug_mode == "2") {
        prmid = this.$_prmid();
      }
      codeinfo_url += "appli/line/";
      codeinfo_url += "getDigitChangeInfo.php?mail=";
      codeinfo_url += email;
      codeinfo_url += "&shopid=";
      codeinfo_url += miseid;
      codeinfo_url += "&prmid=";
      codeinfo_url += prmid;
      codeinfo_url +=
        "&security=" +
        md5(
          email +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            email +
            "!Busicom04510" +
            mmddyyyy
        );
      // window.alert('getMemInf = ' + codeinfo_url);
      await axios
        .get(codeinfo_url)
        //.then((response) => this.users = response.data)
        .then(
          (response) =>
            (document.getElementById("chg_digit_info").innerHTML = response.data)
        )
        .catch((error) => console.log(error));
    },
    /**
     * 既存カードの移行登録 migration()
     * MCMigration.htmlを直接呼び出す処理
     * 0015155:【みせめぐ】LINEミニアプリに「会員カード移行」機能を移植する
     * ※みせめぐMini2.0専用メソッド（JANKENUSERが無い場合の新規登録時には都道府県と性別は初期値のままで生年月日または電話番号のみが登録される）
     */
    migration: async function () {
      //移行処理専用画面
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;

      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }

      // 引数１．mail address
      var email = "undefined";
      try {
        const idToken = await liff.getDecodedIDToken();
        console.log(idToken.email); // print decoded idToken object
        //メルアドが取得できれば表示、取得エラーの場合は入力を促す
        var email = idToken.email;
        if (email == "undefined" || email == null || email == "") {
          var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
          var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
          email = dec_email.toString(CryptoJS.enc.Utf8);
        }
      } catch (Exception) {
        email = "";
      }
      // 引数２．userid
      // var userid = $('#misemeg_uid').val();
      var userid = document.getElementById("misemeg_uid").innerHTML;
      // 引数３．shopid
      // グローバル変数から店舗コードを取得
      var selected_shopid = this.$_shopid();
      // 店舗選択オプション利用フラグ
      var select_shop = this.$_select_shop();
      if (select_shop == "1") {
        // 店舗選択オプション有効(1)の場合店舗選択プルダウンから選択店舗コードを取得する
        selected_shopid = $("#select_shop").val();
        if (!selected_shopid) {
          //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
          selected_shopid = this.$_t_shopid();
          //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
          if (debug_mode == "2") {
            selected_shopid = this.$_shopid();
          }
        }
      } else {
        // 店舗選択オプション無効(0)の場合はグローバル変数にセットした店舗コードを使用
        selected_shopid = this.$_shopid();
      }
      // 接続先サーバーのFQDNをグローバル変数[debug_mode]で切り替える
      // 引数４．svr（接続先サーバー　svr=1はSTG , svr=2は本番運用 ※main.jsのdebug_mode定義に揃えた）
      // 0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var svr = "&svr=1";
      if (debug_mode == "2") {
        svr = "&svr=2";
      }
      /*
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "1") {
        svr = "&svr=1";
        if (i_shopid % 2 == 0) {
          svr = "&svr=4";
        } else {
          svr = "&svr=3";
        }
      } else {
        svr = "&svr=2";
        if (i_shopid % 2 == 0) {
          svr = "&svr=6";
        } else {
          svr = "&svr=5";
        }
      }
      */
      var fqdn = "https://test.misemegu.jp/";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        fqdn = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          fqdn = "https://sv2.misemeg.jp/";
        } else {
          fqdn = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          fqdn = "https://sv2.misemegu.jp/";
        } else {
          fqdn = "https://sv1.misemegu.jp/";
        }
      }

      fqdn = fqdn + "appli/line/relation/";

      // ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼  for PC debug  ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ //
      //　20231004
      // fqdn = "http://iijima.misemegu.jp/appli/line/relation/";
      // fqdn = "http://localhost:83/mg/appli/line/relation/";
      //
      // ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲  for PC debug  ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ //

      //生年月日選択情報（MVMigtation.htmlで再入力を避けるためにparametersで送信）
      // var selected_bdy = btoa($('#bd_year').val());
      // var selected_bdm = btoa($('#bd_month').val());
      // var selected_bdd = btoa($('#bd_date').val());
      var selected_bdy = "";
      var selected_bdm = "";
      var selected_bdd = "";
      // 引数５．chg_digit（桁数変更情報）
      var chg_digit = $("#chg_digit_info").val();
      var bcg = "#00843f";
      // URL生成
      // （サンプル）window.location.href="https://test.misemegu.jp/appli/line/migrationUser.php?mail=YmNpaWppbWFAZ21haWwuY29t&uid=dTA0MDA5MzQ=&sid=NjUxMTI3";
      // var s_url =  fqdn + "appli/line/migrationUser.php?" + "&mail=" + btoa(email) + "&uid=" + btoa(userid) + "&sid=" + btoa(shopid)  + "&cdig=" + chg_digit + svr;
      var s_url =
        fqdn +
        "MCMigration.html?bcg=" +
        btoa(bcg) +
        "&mail=" +
        btoa(email) +
        "&uid=" +
        btoa(userid) +
        "&sid=" +
        btoa(selected_shopid) +
        "&cdig=" +
        chg_digit +
        "&bdy=" +
        selected_bdy +
        "&bdm=" +
        selected_bdm +
        "&bdd=" +
        selected_bdd +
        svr +
        "&openExternalBrowser=1";
      // 別ウィンドウで開く
      // window.alert(s_url);
      window.open(s_url, "_blank");
      // window.open(s_url,'_blank')ではLINE内部ブラウザで別ウィンドウを開く意味を持つ可能性があるためlocation.hrefに変更
      // window.location.href = s_url;

      // この画面自体は5秒待機後に登録完了後の「デジタル会員証を表示する」ボタンの表示されたbridge画面に遷移する
      setTimeout(this.$router.push({ name: "bridge" }), 5000);
    },
    showSnackbar(text) {
      this.snackbarFlag = true;
      this.snackbarText = text;
      setTimeout(() => {
        this.snackbarFlag = false;
        this.snackbarText = "";
      }, this.snackbarTimeout);
    },
  },
};
</script>
